import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {DeviceService} from '../../../../shared/services/device/device.service';
import {faCheckCircle, faTimesCircle} from '@fortawesome/free-solid-svg-icons';
import {StatesService} from '../../../../shared/services/state/states.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {UnitKeyModalComponent} from './unit-key-modal/unit-key-modal.component';
import { MatDialog } from '@angular/material/dialog';
import {ModalService} from '../../../../shared/services/modal/modal.service';

@Component({
  selector: 'app-device-batch-import-csv-loader',
  templateUrl: './device-batch-import-csv-loader.component.html',
  styleUrls: ['./device-batch-import-csv-loader.component.css']
})
export class DeviceBatchImportCsvLoaderComponent implements OnInit {

  @ViewChild('file') fileInput: ElementRef;
  @Output() isLoading: EventEmitter<boolean> = new EventEmitter();
  @Output() quit = new EventEmitter();
  selectedFiles: Set<File> = new Set();
  submitted = false;
  apiResponses: any;
  isAtLeastOneError: boolean;
  createdDevice = 0;
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;

  constructor(private deviceService: DeviceService,
              private statesService: StatesService,
              private toastrService: ToastrService,
              private translateService: TranslateService,
              private modalService: ModalService,
              private matDialog: MatDialog) {
  }

  ngOnInit() {
  }

  addFile() {
    for (const file of this.fileInput.nativeElement.files) {
      this.selectedFiles.add(file);
    }
  }

  postCSVFiles() {
    if (this.selectedFiles.size === 0) {
      this.toastrService.error(this.translateService.instant('FILE_UPLOAD_NEEDED'));
      return;
    }
    this.isLoading.emit(true);
    const filesPostRequests = Array.from(this.selectedFiles).map(
      (file) => {
        const uploadData = new FormData();
        uploadData.append('file', file);
        return this.deviceService.postDeviceBatchImport(uploadData);
      }
    );
    let completedFilesPostRequests = 0;
    filesPostRequests.forEach(
      (request) => request.subscribe(
        (response: any) => {
          completedFilesPostRequests += 1;
          if (completedFilesPostRequests === filesPostRequests.length) {
            this.isLoading.emit(false);
            this.statesService.reloadListDevices.next();
          }
          if (response.errors || response.fileIssue) {
            this.isAtLeastOneError = true;
          }
          this.submitted = true;
          this.createdDevice += response.success;
          this.apiResponses = this.apiResponses ? this.apiResponses.concat([response]) : [response];
        }
      )
    );
  }

  getArray(object) {
    return Object.entries(object);
  }

  newImport() {
    this.selectedFiles.clear();
    this.isAtLeastOneError = false;
    this.apiResponses = undefined;
    this.submitted = false;
    this.createdDevice = 0;
  }

  openUnit() {
    this.matDialog.open(UnitKeyModalComponent, {
      height: '90%',
      width: '95%',
    });
  }
}
